"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_BOOKINGS_USER_OF_USER_END_POINT = exports.BI_BOOKINGS_SRC = void 0;
exports.BI_BOOKINGS_SRC = 16;
exports.BI_BOOKINGS_USER_OF_USER_END_POINT = 'wixboost-ugc';
//# sourceMappingURL=bi-logger.const.js.map